import styled, { css } from 'styled-components';
import Panel from 'components/Panel';
import Doppler from 'components/Doppler';
import { CircularProgress } from '@mui/material';

export default {
  ActivityPanel: styled(Panel)`
    display: flex;
    flex-direction: column;

    & .Panel-top {
      align-items: flex-start;
      flex-direction: column;

      ${({ theme }) => css`
        ${theme.breakpoints.up('sm')} {
          flex-direction: row;
        }
      `}
    }

    & .Panel-title {
      align-items: flex-start;
    }

    & .Panel-actions {
      display: flex;
      width: 100%;
      padding-left: 0;
      margin: 0;

      ${({ theme }) => css`
        ${theme.breakpoints.up('sm')} {
          width: auto;
          padding-left: 1rem;
          margin: -7px;
        }
      `}
    }

    & .Panel-children {
      flex-grow: 1;
    }
  `,

  UnderTitle: styled(Doppler)`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: normal;
    text-transform: none;

    ${({ $noMarginLeft }) => {
      if (!$noMarginLeft) {
        return css`
          margin-left: -24px;
        `;
      }
    }}

    ${({ theme }) => css`
      font-family: ${theme.typography.fontFamily};

      ${theme.breakpoints.up('sm')} {
        font-size: 0.75rem;
        margin-left: 0;
        margin-top: 0;
        margin-bottom: 0.25rem;
      }
    `}
  `,

  TimeframeValue: styled.p`
    margin-bottom: 5px;
    ${({ theme }) => css`
      color: ${theme.palette.dark.main};
      ${theme.breakpoints.up('sm')} {
        margin-bottom: 0;
      }
    `}
  `,

  ActiveChartLabel: styled.p`
    font-weight: bold;
    color: ${({ theme, $color }) => theme.palette[$color].dark};
  `,

  LegendItem: styled.div`
    display: flex;
    align-items: center;
    margin-right: 32px;
    font-size: 1rem;

    ${({ theme }) => css`
      color: ${theme.palette.dark.main};

      ${theme.breakpoints.up('sm')} {
        padding-left: 1rem;
        padding-right: 1rem;
        min-width: 95px;
        margin-right: auto;
      }
    `}
  `,

  LegendIconVal: styled.div`
    ${({ theme }) => css`
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      ${theme.breakpoints.up('sm')} {
     
    `}
  `,

  LegendIcon: styled.div`
    ${({ $color, theme }) => css`
      color: ${$color};
      // position: relative;
      margin-right: 6px;

      &::before {
        content: '';
        display: block;
        top: calc(50% - 4px);
        left: -4px;
        width: 10px;
        height: 10px;
        border-radius: 100rem;
        background-color: currentColor;
      }

      // ${theme.breakpoints.up('sm')} {
      //   margin-right: 10px;
      //   width: 2px;
      //   height: 42px;
      //   background-color: currentColor;
      //
      //   &::before {
      //     position: absolute;
      //   }
      // }
    `}
  `,

  LegendBox: styled(Doppler)`
    display: flex;
    flex-shrink: 0;
    flex-direction: column-reverse;
    justify-content: space-around;
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        height: 100%;
      }
    `}
  `,

  LegendLabel: styled(Doppler)`
    margin-right: 0.25rem;
  `,

  LegendValue: styled(Doppler)`
    font-weight: bold;
  `,

  ActivityPanelInner: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  ActivityChart: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    width: calc(100% + 12px);
    margin-left: -16px;
    height: 143px;
    /* margin-right: -6px; */
  `,

  CircularProgress: styled(CircularProgress)`
    ${({ theme, $color }) => css`
      color: ${theme.palette[$color].main};
    `}
  `,
};
